module.exports = __webpack_public_path__ + "static/media/OurWork_Tablet.8ec3be01.svg";